import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/img/ravenlogo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Header() {
  const toggleMenu = () => {
    const nav = document.querySelector('nav');
    nav.classList.toggle('open');
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={Logo} alt="" />
      </div>

      <nav className="nav">
        <div className="left">
          <Link to={'/'}>Home</Link>
          <Link to={'/about'}>FAQs</Link>
          <Link to={'/contact'}>Contact</Link>
        </div>

        <div className="right">
          <button>
            Login{' '}
            <FontAwesomeIcon
              className="icon"
              icon={['fa', 'arrow-right']}
              size="2x"
            />
          </button>
        </div>
      </nav>

      <div className="menu-toggle show-mobile" onClick={toggleMenu}>
        <FontAwesomeIcon icon={['fa', 'bars']} />
      </div>
    </header>
  );
}
